<template>
  <v-container>
    <v-layout
      column
      justify-center
      align-center
      fill-height
    >
      <div class="reset-password-title">
        <h3 class="display-1 mb-3 font-weight-medium">
          {{ this.$t('resetPassword.title') }}
        </h3>
        <div class="reset-password-subtitle">
          {{ this.$t('resetPassword.subtitle') }}
        </div>
      </div>
      <ResetPasswordForm />
    </v-layout>
  </v-container>
</template>

<script>
import ResetPasswordForm from '../components/ResetPasswordForm'

export default {
  name: 'ResetPasswordPage',
  components: {
    ResetPasswordForm,
  },
}
</script>

<style lang="stylus" scoped>
.reset-password-title {
  margin-bottom: 2em;
}

@media only screen and (max-width: 480px) {
  .reset-password-subtitle {
    padding: 0 1em;
  }
}
</style>
